module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-38.35afb1f4.png";